module.exports = __webpack_public_path__ + "img/backups.2b924199.jpeg";